import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromEvent from '../reducers/events.reducer';
import * as fromRoot from '../../../store';
import * as fromAuth from '../../../auth/store';
import { Event } from '../../models';
import { findNearest, getDistance } from 'geolib';
import { getGeoLocationPosition } from '../../../geo-location/store';

export const getEventState = createSelector(fromFeature.getEventsState, (state: fromFeature.EventState) => state.events);

export const getEventsEntities = createSelector(getEventState, fromEvent.getEventsEntities);

export const getAllEvents = createSelector(getEventsEntities, entities => {
  return Object.keys(entities).map(id => entities[+id]);
});

export const getEventsLoaded = createSelector(getEventState, fromEvent.getEventsLoaded);
export const getEventsLoading = createSelector(getEventState, fromEvent.getEventsLoading);
export const getEventsSortOrder = createSelector(getEventState, fromEvent.getEventsSortOrder);
export const getEventSaved = createSelector(getEventState, fromEvent.getEventSaved);
export const getEventSaving = createSelector(getEventState, fromEvent.getEventSaving);
export const getEventsPage = createSelector(getEventState, fromEvent.getEventsPage);

export const getOrderedEvents = createSelector(
  getAllEvents,
  getEventsPage,
  getEventsSortOrder,
  getGeoLocationPosition,
  (events, page, order, position) => {
    if (!position) {
      return events.sort((a, b) => +b.featured - +a.featured || (new Date(a.start || '') > new Date(b.start || '') ? 1 : -1));
    }

    switch (order) {
      case 0:
        return events.sort((a, b) => +b.featured - +a.featured || (new Date(a.start || '') > new Date(b.start || '') ? 1 : -1));
      case 1:
        return events.sort((a, b) => {
          var p = position as any;

          if (!a.locations?.length || !b.locations?.length) {
            return 0;
          }

          // Sort by the distance of the closest location in a.locations
          var aLoc = findNearest({ latitude: p.coords.latitude, longitude: p.coords.longitude }, a.locations);
          var bLoc = findNearest({ latitude: p.coords.latitude, longitude: p.coords.longitude }, b.locations);

          return (
            getDistance({ latitude: p.coords.latitude, longitude: p.coords.longitude }, aLoc) -
            getDistance({ latitude: p.coords.latitude, longitude: p.coords.longitude }, bLoc)
          );
        });
      default:
        return events.sort((a, b) => +b.featured - +a.featured || (new Date(a.start || '') > new Date(b.start || '') ? 1 : -1));
    }
  }
);

export const getMyEvents = createSelector(getAllEvents, fromAuth.getAuthUser, (events, usr) => {
  return events?.filter(a => a.createdById === usr?.id);
});

export const getSelectedEvent = createSelector(getEventsEntities, fromRoot.getRouterState, (entities, router): Event => {
  return router.state && entities[router.state.params?.['eventId'] || router.state.data?.['id']];
});

export const getSelectedEventLoaded = createSelector(getSelectedEvent, (c: Event) => {
  return c?.loaded;
});

export const getSelectedEventLoading = createSelector(getSelectedEvent, (c: Event) => {
  return c?.loading;
});
